// extracted by mini-css-extract-plugin
export default {"myfontsShortCircle":"fouxKZHrIL8","hover":"fout0JXduaI"};